import { Injectable } from '@angular/core';
import { FILTER_TYPES } from '../config/enum';
import { PathConfig } from '../config/path.config';

@Injectable({
  providedIn: 'root'
})
export class ExcelTypeFilterService {

  private config: any = {
    transaction: {
      apiEndpoint: [PathConfig.LOAN_TRANSACTIONS, PathConfig.LOAN_TRANSACTIONS_IMPORTED],
      columns: {
        payment_code: {
          type: FILTER_TYPES.STRING,
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'code',
            paramName: ['unique_payment_code', 'payment_codes']
          }
        },
        payment_effective_date: {
          type: FILTER_TYPES.DATE,
          uniqueFilter: {
            identifier: 'payment_date',
            textFieldName: 'payment_date',
            paramName: ['unique_payment_effective_date', 'payment_effective_dates']
          }
        },
        payment_amount: {
          type: FILTER_TYPES.CURRENCY,
          uniqueFilter: {
            identifier: 'payment_amount',
            textFieldName: 'payment_amount',
            paramName: ['unique_payment_amount', 'payment_amounts']
          }
        },
        payment_method: {
          type: FILTER_TYPES.STRING,
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'source',
            paramName: ['unique_payment_method', 'payment_methods']
          }
        },
        payment_waterfall_model: {
          type: FILTER_TYPES.STRING,
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'code',
            paramName: ['unique_waterfall_code', 'payment_waterfall_codes']
          }
        },
        payment_status: {
          type: FILTER_TYPES.STRING,
          uniqueFilter: {
            identifier: 'payment_status',
            textFieldName: 'payment_status',
            paramName: ['unique_payment_status', 'payment_statuses']
          }
        },
      }
    },
    activity_note: {
      apiEndpoint: [PathConfig.LOAN_ACTIVITY_NOTES, PathConfig.LOAN_ACTIVITY_NOTES_IMPORTED],
      columns: {
        activity_type: {
          type: FILTER_TYPES.STRING,
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'title',
            paramName: ['unique_activity_type', 'activity_types']
          }
        },
        phone_number: {
          type: FILTER_TYPES.PHONE,
          addClass:['align-self-center'],
          uniqueFilter: {
            identifier: 'phone_number',
            textFieldName: 'phone_number',
            paramName: ['unique_activity_phone', 'phone_numbers'],
            additionalTextFieldName: 'phone_title'
          }
        },
        agent_name: {
          type: FILTER_TYPES.STRING,
          uniqueFilter: {
            identifier: 'activity_note_agent_name',
            textFieldName: 'activity_note_agent_name',
            paramName: ['unique_activity_agent', 'agent_names']
          }
        },
        ptp_date: {
          type: FILTER_TYPES.DATE,
          uniqueFilter: {
            identifier: 'ptp_date',
            textFieldName: 'ptp_date',
            paramName: ['unique_ptp_date', 'ptp_dates']
          }
        },
        ptp_amount: {
          type: FILTER_TYPES.CURRENCY,
          uniqueFilter: {
            identifier: 'ptp_amount',
            textFieldName: 'ptp_amount',
            paramName: ['unique_ptp_amount', 'ptp_amounts']
          }
        },
      }
    },
  };

  getColumnConfig(table: string, column: string) {
    return this.config?.[table]?.columns?.[column];
  }

  getApiEndpoint(table: string, historicData: any = 0) {
    return this.config?.[table]?.apiEndpoint[historicData];
  }

  getParams(table: string, column: string, paramName: any = 0) {
    return this.config?.[table]?.columns?.[column]?.uniqueFilter?.paramName[paramName] ?? null;
  }
}
